module.exports = __webpack_public_path__ + "static/media/garden.6f3f086e.jpg";